import { FC } from 'react'
import { Box, BoxProps, Typography } from '@mui/material'
import VerifiedUserOutlinedIcon from '@mui/icons-material/VerifiedUserOutlined'
import { TEXT_DARK_COLORS_VARIANTS } from '@/utils/constants/colors'

export const ComplianceMicroBar: FC<BoxProps> = (boxProps) => (
  <Box display="flex" alignItems="center" justifyContent="center" gap={0.75} px={1} {...boxProps}>
    <VerifiedUserOutlinedIcon
      aria-hidden
      sx={{ fontSize: '0.875rem', color: TEXT_DARK_COLORS_VARIANTS[280], flexShrink: 0 }}
    />
    <Typography
      fontSize="0.75rem"
      fontWeight={500}
      color={TEXT_DARK_COLORS_VARIANTS[280]}
      textAlign="center"
      lineHeight={1.4}
    >
      18+ · UK residents only · No credit cards
    </Typography>
  </Box>
)
